import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/utils";

export const buttonVariants = cva("button", {
  variants: {
    variant: { primary: "button--primary", secondary: "button--secondary", outline: "button--outline", ghost: "button--ghost", danger: "button--danger" },
    size: { sm: "button--sm", md: "button--md" },
  },
  defaultVariants: { variant: "primary", size: "md" },
});

type Props = ButtonHTMLAttributes<HTMLButtonElement> & VariantProps<typeof buttonVariants> & { asChild?: boolean; icon?: ReactNode };
export function Button({ variant, size, asChild = false, icon, className, children, ...props }: Props) {
  const Comp = asChild ? Slot : "button";
  return <Comp className={cn(buttonVariants({ variant, size }), className)} {...props}>{icon}{children}</Comp>;
}
